import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMeta } from '../lib/metaPixel';

// Fires a Meta PageView on SPA route changes (the initial PageView is sent on pixel load).
const MetaPageView = () => {
  const { pathname } = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackMeta('PageView');
  }, [pathname]);

  return null;
};

export default MetaPageView;
